import { createContext, useCallback, useContext, useState } from "react";
import ApiBiometria from "../Utils/AxiosBiometria";

export const BiometricValidationContext = createContext({});

export function BiometricValidationProvider({ children }) {
  const [signInLoading, setSignInLoading] = useState(false);
  const [biometricInfo, setBiometricInfo] = useState(null);
  const [biometricInfoLoading, setBiometricInfoLoading] = useState(false);
  const [acceptTermsLoading, setAcceptTermsLoading] = useState(false);

  const onSign = useCallback(async ({ phone, token }) => {
    try {
      setSignInLoading(true);

      const response = await ApiBiometria.post("/v1/auth", {
        phone,
        token,
      });
      if (response) {
        localStorage.setItem(
          "@flexgr-validacao-facial:hash",
          JSON.stringify(response?.data?.hash),
        );
        localStorage.setItem(
          "@flexgr-validacao-facial:token",
          JSON.stringify(response?.data?.token),
        );
      }

      return {
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      throw error.response?.data || error;
    } finally {
      setSignInLoading(false);
    }
  }, []);

  const onGetBiometricInfo = useCallback(async ({ hash }) => {
    try {
      setBiometricInfoLoading(true);

      const response = await ApiBiometria.post("/v1/get-info-biometria", {
        hash,
      });

      if (response) {
        setBiometricInfo(response?.data?.data);
      }

      return {
        data: response?.data?.data,
        status: response?.data?.code,
      };
    } catch (error) {
      throw error.response?.data || error;
    } finally {
      setBiometricInfoLoading(false);
    }
  }, []);

  const onAcceptTerms = useCallback(
    async (
      { hash, aceito_termo, geo_localizacao },
      //  {
      //   hash: string;
      //   aceito_termo: boolean;
      //   geo_localizacao:
      //   {
      //     endereco: string;
      //     latitude: number;
      //     longitude: number;
      //     cidade: string;
      //     uf: string;
      //   }
      // }
    ) => {
      try {
        setAcceptTermsLoading(true);

        const response = await ApiBiometria.post(
          "/v1/get-geolocalizacao-biometria",
          {
            hash,
            aceito_termo,
            geo_localizacao,
          },
        );
        return {
          data: response?.data?.data,
          status: response?.data?.code,
        };
      } catch (error) {
        throw error.response?.data || error;
      } finally {
        setAcceptTermsLoading(false);
      }
    },
    [],
  );

  return (
    <BiometricValidationContext.Provider
      value={{
        signInLoading,
        biometricInfo,
        biometricInfoLoading,
        acceptTermsLoading,
        onSign,
        onGetBiometricInfo,
        onAcceptTerms,
      }}
    >
      {children}
    </BiometricValidationContext.Provider>
  );
}

export const useBiometricValidation = () => {
  const context = useContext(BiometricValidationContext);

  if (context === undefined)
    throw new Error(
      "useBiometricValidation must be used within a BiometricValidationProvider",
    );

  return context;
};
